import { Base } from "ui/Scripts/source/framework/base";
import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { ISettings, Settings } from "./settings";

export interface ISettingsEdit {
    settings: ISettings;
    themes: IIdTitle[];
    cultures: IIdTitle[];
}

export class SettingsEdit implements ISettingsEdit {
    settings: Settings;
    themes: IdTitle[];
    cultures: IdTitle[];

    constructor();
    constructor(obj: ISettingsEdit);
    constructor(obj?: any) {
        this.settings = new Settings(obj?.settings);
        this.themes = Base.getTypedArray(obj ? obj.themes : null, IdTitle);
        this.cultures = Base.getTypedArray(obj ? obj.cultures : null, IdTitle);
    }
}